import React from 'react'
import styles from './not_found_result.module.css'
import strings from '../../strings/strings.json'

export default function NotFoundResult() {

    return (
        <div className={styles.container}>
            <div className="flex justify-center">
                <img className={styles.img} src='/assets/icons/not_found_result.svg' alt="Not Found Result" />
            </div>
            <span className={styles.title}>{strings.general_notFoundResultTitle}</span>
            <span className={styles.subTitle}>{strings.general_notFoundResultSubTitle}</span>
        </div>
    )
}